var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.945,
    height: 80.947,
    viewBox: "0 0 80.945 80.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.945,
    height: 80.947,
    transform: "translate(0 0)",
    fill: "#fcc20a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,9.023H12.54L8.88,23.105H11.6L15.188,9.312V6.784H8.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5,57.162A6.172,6.172,0,0,1,38.67,45.1v2.3a4.04,4.04,0,1,0,3.657-.005V45.1A6.171,6.171,0,0,1,40.5,57.162m-.88-13.256a.883.883,0,0,1,1.762,0v4.073a.883.883,0,0,1-1.762,0Zm.878-4.687A11.864,11.864,0,1,0,52.364,51.082,11.863,11.863,0,0,0,40.5,39.219",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.884,50.979a.993.993,0,0,0-.912-.974H20.777a.978.978,0,0,0,0,1.952h5.195a1,1,0,0,0,.912-.978",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.152,50.979a.993.993,0,0,0-.912-.974h-5.2a.978.978,0,0,0,0,1.952h5.2a1,1,0,0,0,.912-.978",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.507,37.36a.992.992,0,0,0,.973-.911v-5.2a.977.977,0,0,0-1.951,0v5.2a1,1,0,0,0,.978.911",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.684,44.213a.991.991,0,0,0-.307-1.3l-4.509-2.58a.977.977,0,0,0-.969,1.693l4.509,2.58a.993.993,0,0,0,1.276-.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.273,39.16a.992.992,0,0,0,1.3-.307l2.581-4.509a.978.978,0,0,0-1.694-.97l-2.58,4.509a.994.994,0,0,0,.4,1.277",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.717,39.172a.993.993,0,0,0,.39-1.276l-2.59-4.5a.977.977,0,0,0-1.691.973l2.589,4.5a.994.994,0,0,0,1.3.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.314,44.192a.993.993,0,0,0,1.275.39l4.5-2.59a.977.977,0,0,0-.971-1.691l-4.5,2.589a1,1,0,0,0-.3,1.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.484,64.628a.992.992,0,0,0-.973.911v5.2a.977.977,0,0,0,1.951,0v-5.2a1,1,0,0,0-.978-.911",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.307,57.774a.991.991,0,0,0,.307,1.3l4.509,2.58a.977.977,0,0,0,.969-1.693l-4.509-2.58a.993.993,0,0,0-1.276.395",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.719,62.827a.992.992,0,0,0-1.3.307l-2.581,4.509a.978.978,0,0,0,1.694.97l2.58-4.509a.994.994,0,0,0-.4-1.277",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.275,62.815a.993.993,0,0,0-.39,1.276l2.59,4.5a.977.977,0,0,0,1.691-.973l-2.589-4.5a.994.994,0,0,0-1.3-.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.677,57.795A.993.993,0,0,0,27.4,57.4l-4.5,2.59a.977.977,0,0,0,.971,1.691l4.5-2.589a1,1,0,0,0,.3-1.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.348,11.293h.888L24.8,8.639h-.01Zm-1.4,2.1L24.2,6.776H25.47l1.259,6.614H25.587l-.2-1.21H24.2l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.139,6.776h2.6v.907H28.251V9.576h1.112v.9H28.251V13.39H27.139Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.183,6.776h2.6v.907H31.3V9.576h1.112v.9H31.3V13.39H30.183Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.385,11.859V8.308c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.195,7.683V9.741h.371a.481.481,0,0,0,.546-.546V8.22c0-.361-.166-.537-.546-.537Zm0,2.673V13.39H37.083V6.776H38.7c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278L40.41,13.39H39.239Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.372,12.483c.458,0,.634-.273.634-.673V8.347a.579.579,0,0,0-.634-.663H41.9v4.8Zm1.746-3.931v3.063c0,1.015-.42,1.775-1.61,1.775H40.791V6.776h1.717c1.19,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.777,11.293h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614H46.9l1.258,6.614H47.016l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.68,10.415v2.068h.488a.479.479,0,0,0,.547-.537v-.995c0-.351-.166-.536-.556-.536Zm0-.849h.391a.468.468,0,0,0,.526-.537V8.22a.468.468,0,0,0-.536-.537H49.68Zm-1.112-2.79h1.61c1.112,0,1.483.517,1.483,1.453V8.9A.963.963,0,0,1,51,9.956a1,1,0,0,1,.83,1.1v.878c0,.937-.42,1.454-1.532,1.454H48.568Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.334,6.776h1.112v5.707h1.327v.907H52.334Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.232,6.776h2.654v.907H56.344V9.576h1.1v.9h-1.1v2.01h1.542v.907H55.232Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.628,11.293h.888l-.439-2.654h-.009Zm-1.394,2.1,1.248-6.614H61.75l1.259,6.614H61.868l-.206-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.356,9.234V13.39h-.937V6.776h1.093l1.2,3.794V6.776h.927V13.39h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.806,12.483c.458,0,.634-.273.634-.673V8.347a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.42,1.775-1.61,1.775H67.225V6.776h1.717c1.19,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.12,21.4V18.212a1.552,1.552,0,0,1,1.651-1.776c1.223,0,1.563.679,1.563,1.65v.777h-1.01V18c0-.408-.136-.641-.534-.641s-.563.281-.563.68v3.534c0,.4.165.679.563.679s.534-.252.534-.64V20.4h1.01v1.136c0,.942-.388,1.641-1.563,1.641A1.557,1.557,0,0,1,23.12,21.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.032,16.514h1.107v5.68H29.46v.9H27.032Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.06,16.514H32.7v.9H31.167V19.3h1.1v.894h-1.1v2H32.7v.9H30.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,21.01h.883l-.437-2.641h-.01ZM33.216,23.1l1.243-6.583h1.262L36.974,23.1H35.838l-.2-1.2H34.459l-.194,1.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.458,18.96V23.1h-.932V16.513h1.087l1.194,3.777V16.513h.923V23.1h-.971Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.69,16.514h2.641v.9H44.8V19.3h1.1v.894H44.8v2h1.534v.9H43.69Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.923,18.96V23.1h-.932V16.513h1.087l1.194,3.777V16.513H50.2V23.1h-.971Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.913,16.514h2.641v.9H52.02V19.3h1.1v.894h-1.1v2h1.534v.9H50.913Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.33,17.417v2.048H55.7a.479.479,0,0,0,.544-.543v-.971c0-.36-.165-.534-.544-.534Zm0,2.66V23.1H54.223V16.514h1.612c1.116,0,1.524.553,1.524,1.476v.844c0,.709-.252,1.126-.883,1.272L57.534,23.1H56.369Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.728,19.582H61.3V23.1h-.8v-.719a1,1,0,0,1-1.058.8c-.952,0-1.389-.757-1.389-1.776V18.213a1.56,1.56,0,0,1,1.66-1.777c1.224,0,1.583.68,1.583,1.651v.582h-1.01V18c0-.407-.155-.64-.553-.64s-.573.281-.573.679v3.534c0,.4.165.68.543.68.36,0,.544-.2.544-.631V20.456h-.524Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.164,20.592V23.1H63.057V20.592l-1.233-4.078H62.98l.67,2.495h.009l.67-2.495h1.059Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG07);
export default __webpack_public_path__ + "static/media/G07.75df9f4d6057053bdc0490e28aa7d4b7.svg";
export { ForwardRef as ReactComponent };